import { useQuote } from "../lib/quoteContext";

export default function About() {
  const { openQuote } = useQuote();
  return (
    <section
      id="about"
      className="py-20 lg:py-28 bg-[#DCEBFB]"
      data-testid="about-section"
    >
      <div className="max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        {/* Photo with offset frame */}
        <div className="lg:col-span-5 relative">
          <div
            className="absolute -inset-2 rounded-[22px] bg-[#183B87]"
            style={{ transform: "rotate(-3deg)" }}
            aria-hidden
          />
          <img
            src="https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/z5y1pddk_Background%2BBorder.png"
            alt="Tina, founder of Tina's Cleaning Company"
            className="relative rounded-[22px] w-full h-[360px] sm:h-[420px] lg:h-[460px] object-cover"
            style={{ transform: "rotate(-2deg)" }}
            data-testid="about-photo"
          />
        </div>

        {/* Text */}
        <div className="lg:col-span-7">
          <p className="tc-eyebrow mb-3">About Us</p>
          <h2 className="font-serif text-[32px] sm:text-[40px] lg:text-[48px] text-[#173B86] leading-[1.05] tracking-[-0.01em] max-w-[640px]">
            We Don't Just Clean Homes. We Restore Calm.
          </h2>

          <div className="mt-5 space-y-4 text-[14.5px] sm:text-[15px] leading-[1.7] text-[#1A2B4A]/90 max-w-[640px]">
            <p>
              Hi, I'm Tina — the founder of Tina's Cleaning Company. I built my
              team on trust, responsibility, and attention to detail. I brought
              together a team that treats like its own — for us, cleaning is
              not just a job, it's care for your home.
            </p>
            <p>
              Our team consists of 7 professional cleaners, each with at least
              5 years of experience. We are all Ukrainian by origin, but we
              speak English fluently and feel comfortable working with a wide
              range of clients. We work smoothly, carefully, and with respect
              for every space we enter.
            </p>
            <p>
              We've been providing reliable, high-quality cleaning services for
              over 6 years. We use effective cleaning products that handle even
              tough messes while remaining safe for your home and health.
            </p>
            <p>
              We are a licensed and fully insured company, so you can feel
              confident and secure with every service we provide.
            </p>
            <p>
              We always adapt to each client's needs — taking into account
              budget, schedule, pets in the home, and the presence of children.
            </p>
            <p>
              We keep the process simple: flexible scheduling, transparent
              pricing, and quick, easy booking with no unnecessary calls.
            </p>
          </div>

          <button
            onClick={() => openQuote()}
            className="tc-btn-primary mt-8"
            data-testid="about-cta"
          >
            Get a Quote
          </button>
        </div>
      </div>
    </section>
  );
}
